"use strict";
import Swal from 'sweetalert2/dist/sweetalert2';
import * as signalR from "@microsoft/signalr";

export default (function () {
    let messagingHiddenInput = $('#MessagingEnabled');
    let messagingEnabled = messagingHiddenInput.length > 0 ? messagingHiddenInput.val().toLowerCase() === 'true' : false;

    if (!messagingEnabled) {
        console.log('Messaging disabled.');
        return;
    }

    console.log('Messaging enabled: connecting to hub.');

    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/realTimeMessaging")
        .withAutomaticReconnect()
        .build();

    connection.on("NotifyNewMessageReceived", (message) => {
        try {
            $.get("/Notification/Header")
                .done(function (response) {
                    $(".header-navigation").html(response);
                    global.letterAvatarTransform();
                    global.setupHeaderAvatarMenu();
                    global.setupNotificationHeader();
                    global.configureNotificationTab();
                    global.configureNotificationClick();
                    global.configureMainSearch();

                    if (window.location.pathname.toLowerCase().includes('/messaging')) {
                        var conversationId = global.getSelectedContactId();

                        if (conversationId === message.conversationId) {
                            global.refreshMessageChat();
                        } else {
                            global.refreshMessageList();
                        }
                    }
                }).
                fail(function (xhr, status, error) {
                    if (xhr && xhr.status == 401) {
                        document.location.reload();
                    }
                });
        }
        catch (exception) {
            console.error(exception);
        }
        try {
            // Note: SignalR auto camel-cases all properties
            Swal.fire('New Message', `New message received from ${message.conversation?.contactName}`);
        }
        catch (exception) {
            console.error(exception);
        }
    });

    connection.start().catch((err) => {
        // Messaging optional module, can be disabled
        //console.error(err)
    });
}());